import './CoralSocialCards.scss'

import { Asset } from '@websrc/App/Components/Asset/Asset'
import { CoralCardsSlider } from '@websrc/App/Components/CoralCardsSlider/CoralCardsSlider'
import { CoralHeading } from '@websrc/App/Components/CoralHeading/CoralHeading'
import { mapCoralWebSocialCards } from '@websrc/DataMappers/mapSpot'
import React, { FC } from 'react'

import IconProvider from '../../../coral-library/icons/IconProvider'
import Logo from './assets/logo.png'

type CoralSocialCardsProps = ReturnType<typeof mapCoralWebSocialCards>

export const CoralSocialCards: FC<CoralSocialCardsProps> = (props) => {
  const [pausedVideos, setPausedVideos] = React.useState<Record<number, boolean>>({})

  return (
    <div className={'category-coral-spot'}>
      <div className={'coral-social-cards'}>
        <CoralHeading header={props.header} />
        <div className={'coral-social-cards__container'}>
          <CoralCardsSlider forceRow={true}>
            {props.socialVideos &&
              props.socialVideos.length > 0 &&
              props.socialVideos.map((socialPost, id) => (
                <a
                  className={'coral-social-cards__card'}
                  href={socialPost.link}
                  key={id}
                  rel={'noopener noreferrer'}
                  target={'_blank'}
                >
                  <div
                    onMouseEnter={() => {
                      setPausedVideos((prev) => ({ ...prev, [id]: false }))
                    }}
                    onMouseLeave={() => {
                      setPausedVideos((prev) => ({ ...prev, [id]: true }))
                    }}
                  >
                    <Asset
                      altText={socialPost?.altText}
                      className={'coral-social-cards__video'}
                      forcePauseVideo={pausedVideos[id] ?? true}
                      lazyLoading={true}
                      loopAnimation={true}
                      objectFit={'cover'}
                      resetOnPause={true}
                      srcSetWidths={[400, 600, 800, 1200, 1600]}
                      video={socialPost.asset?.video}
                    />
                  </div>

                  <div className={'coral-social-cards__card-info'}>
                    <div className={'coral-social-cards__card-account'}>
                      <div className={'coral-social-cards__card-account-logo'} tabIndex={0}>
                        <img alt={'lego-education'} src={Logo} />
                      </div>
                      <div className={'coral-social-cards__card-account-data-container'}>
                        <div className={'coral-social-cards__card-account-name-container'}>
                          <div className={'coral-social-cards__card-account-name'}>
                            legoeducation
                          </div>
                          <div className={'coral-social-cards__card-account-tick-icon'}>
                            <IconProvider name={'verified'} size={16} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={'coral-social-cards__card-info-instagram'}>
                      <IconProvider name={'instagram'} size={35} />
                    </div>
                  </div>
                </a>
              ))}
          </CoralCardsSlider>
        </div>
      </div>
    </div>
  )
}
